<template>
  <v-dialog :value="value" width="800px" persistent>
    <v-card>
      <v-card-title class="headline">
        Email Details
        <v-spacer></v-spacer>
        <EmailDeliveryStatusChip :value="status" />
      </v-card-title>
      <v-card-text class="black--text">
        <div>
          <elwrapper label="From" midtext>{{ from }}</elwrapper>
          <elwrapper label="To" midtext>
            <v-chip v-for="(email, index) in to" :key="index" class="mr-2">{{ email }}</v-chip>
          </elwrapper>
          <elwrapper label="Subject" midtext>
            <span>{{ subject }}</span>
            <span v-if="!subject" class="red--text caption">(No subject)</span>
          </elwrapper>
        </div>
        <div class="my-2"></div>
        <div class="email-body-container" v-html="body"></div>
        <div class="my-2"></div>
        <div v-if="attachments.length > 0">
          <elwrapper label="Attachments" midtext>
            <v-chip
              color="primary"
              v-for="(file, index) in attachments"
              :key="file.lastModified"
              class="mr-2"
              @click="openAttachment(file.key)"
            >
              <span>{{ file.filename }}</span>
            </v-chip>
          </elwrapper>
        </div>
        <div class="my-2"></div>
        <div v-if="item.status === 'failed' && item.failed_reason">
          <v-alert dense text color="error" class="caption mt-3">
            <v-icon x-small left color="error">priority_high</v-icon>
            <span>Error: {{ item.failed_reason }}</span>
          </v-alert>
        </div>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn text depressed small @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EmailDeliveryStatusChip from "./EmailDeliveryStatusChip";
export default {
  components: {
    EmailDeliveryStatusChip,
  },
  props: {
    value: { type: Boolean, required: true },
    item: { type: Object, required: true },
  },
  computed: {
    from() {
      return this.item?.from || "";
    },
    to() {
      return this.item?.to ? JSON.parse(this.item.to) : [];
    },
    subject() {
      return this.item?.subject || "";
    },
    status() {
      return this.item?.status || "";
    },
    body() {
      return this.item?.body || "";
    },
    attachments() {
      if (!this.item?.attachments) return [];
      return JSON.parse(this.item.attachments);
    },
  },
  methods: {
    statusColor(status) {
      if (status === "pending") return "primary";
      if (status === "sent") return "green";
      if (status === "failed") return "red";
      return "primary";
    },
    close() {
      this.$emit("input", false);
    },
    openAttachment(key) {
      const url = this.$store.getters["host"] + "storage/" + key;
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss">
.email-body-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #fafafa;
  width: 100%;
}
</style>
